<template>
  <el-autocomplete class="inline-input" v-model="obj[nameProName]" :fetch-suggestions="querySearch" 
    :trigger-on-focus="false" ref="cityInput"
    :placeholder="placeholderText==''?'请输入'+(this.searchType==1?'城市':'国家')+'名称':placeholderText" 
    @select="handleSelect($event,obj)" value-key="value" :size="sizeType" :style='width'
    slot="reference" @input="inputValue">
    <template slot-scope="{ item }">
      <div class="name">{{item.cityNameCn}}({{item.countryNameCn}})</div>
    </template>
  </el-autocomplete>
</template>

<script>
import Api from '@/components/Api/index.js'
export default {
  props:{
    searchType:{
      type:Number,
      default:1,
    },
    nameProName:{
      type:String,
      default: 'cityName'
    },
    idProName:{
      type:String,
      default: 'cityId'
    },
    obj:{
      type:Object,
      default: ()=>{return{}}
    },
    width:{
      type:String,
      default:''
    },
    action:{
      type:Boolean,
      default:true,//为false是handle方法交由父组件自己处理
    },
    placeholderText:{
      type:String,
      default:''
    },
    sizeType:{
      type:String,
      default:'mini'
    }
  },
  methods:{
    querySearch(queryString, cb){
      console.log('世界的角度讲');
      if(this.searchType==1){
        new Api('resource').cityList({cityName:queryString,countryId:null}).then(res => {
          if (res.status == 200) {
            cb(res.data)
          }
        })
      }else{
        new Api('resource').countryList({countryName:queryString}).then(res => {
          if (res.status == 200) {
            cb(res.data)
          }
        })
      }  
    },
    handleSelect(item,obj){
      if(this.action){
        if(this.searchType==1){
          obj[this.idProName]=item.id
          obj[this.nameProName]=item.cityNameCn
        }else{
          obj[this.idProName]=item.id
          obj[this.nameProName]=item.countryNameCn
        }
      }else{
        this.$emit("handleSelect",item)
      }
    },
    inputValue(value){
      if(value==''){
        this.$emit("clearData")
      }
    }
  }
}
</script>

<style>

</style>